module.exports = __webpack_public_path__ + "img/2.c3abea2f.jpg";